//import moment from '@/moment-gp'
import $models from '@/models'

export default {
  /* Be very careful to subscribe to this high frequency timer. Everything
  that uses this getters will probably get triggered every seconds.
  This should especially be avoided in (big) templates -> better split them
  up and only subscribe in the sub component to time_updated_every_sec, so
  only the sub component get's re-rendered. */
  time_updated_every_sec: (state) => state.time_updated_every_sec,

  now_updated_every_min: (state) => state.now_updated_every_min,

  session_timer_status: (state, getters, rootState) => taskId => {
    let timer_data = getters.session_user_timer
    if (!taskId) {
      return state.timer_status
    }
    if (timer_data && timer_data.taskId === taskId && getters.session_timer_status ) {
      return state.timer_status
    } else {
      return 'stopped'
    }
  },

   /* time left on the real clock in seconds */
  session_time_remaining: (state, getters, rootState, rootGetters) => taskId => {
    let timer_data = getters.session_user_timer
    if (timer_data.$ready && timer_data.startedAt && timer_data.durationRemaining) {
      let currentTime = state.time_updated_every_sec
      if (timer_data.taskId === taskId && getters.session_timer_status && state.timer_status === 'running') {
        return Math.max(0, timer_data.startedAt + timer_data.durationRemaining - currentTime);
      } else if (timer_data.taskId === taskId && getters.session_timer_status && state.timer_status === 'paused') {
        return Math.max(0, timer_data.durationRemaining);
      } else {
        return 0
      }
    }
    return 0;
  },

  /* time left on the real clock in seconds */
  session_time_elapsed: (state, getters, rootState, rootGetters) => {
    if (getters.session_user_timer && getters.session_user_timer.$ready && getters.session_user_timer.startedAt) {
      let currentTime = state.time_updated_every_sec;
      let timer_data = getters.session_user_timer
      if ( state.timer_status  && state.timer_status === 'running') {
        return currentTime - timer_data.startedAt;
      } else {
        return 0
      }
    }
    return 0;
  },

  session_timer_duration: (state, getters, rootState, rootGetters) => {
    if (getters.session_user_timer.$ready && getters.session_user_timer.startedAt) {
      let timer_data = getters.session_user_timer
      return timer_data.durationRemaining
    }
    return 0
  },

  session_timer_taskId: (state, getters, rootState, rootGetters) => {
    let timer_data = getters.session_user_timer
    if (timer_data && timer_data.$ready) {
      return timer_data.taskId
    } else {
      return null
    }
  },

  session_timer_goalId: (state, getters, rootState, rootGetters) => {
    let timer_data = getters.session_user_timer
    if (timer_data && timer_data.$ready) {
      return timer_data.goalId
    } else {
      return null
    }
  },

  session_user_timer: (state, getters, rootState, rootGetters) => {
    if ($models.user.defaultUserId) {
      return $models.userTimer.subscribeNode( $models.user.defaultUserId )
    } else {
      return null
    }
  },

  session_active_task: (state, getters, rootState, rootGetters) => {
    let timer_data = getters.session_user_timer
    if (timer_data && timer_data.$ready) {
      if (timer_data.goalId && timer_data.taskId) {
        return $models.taskMeta
          .with({ goalId: timer_data.goalId, uid: $models.user.defaultUserId })
          .subscribeNode( timer_data.taskId )
      }
    }
    return null
  },

  session_filterByGoalId: (state) => {
    return state.filterByGoalId
  },
  session_filterByCommitmentId: (state) => {
    return state.filterByCommitmentId
  },
  session_filterByTscId: (state) => {
    return state.filterByTscId
  },

  session_system_time: (state) => {
    return state.time_updated_every_sec
  },

  session_system_time_60s: (state) => {
    return state.now_updated_every_min
  },

  session_active_session_index: (state, getters, rootState, rootGetters) => {
    if (state.activeSessionIndex !== null) {
      return state.activeSessionIndex
    } else {
      return 0
    }
  },
  session_active_session: (state, getters, rootState, rootGetters) => {
    if (state.activeSession !== null) {
      return state.activeSession
    } else {
      return 0
    }
  },
  session_next_session_time_until_end: (state, getters, rootState, rootGetters) => {
    if (state.activeSessionTimeUntilEnd !== null) {
      return state.activeSessionTimeUntilEnd
    } else {
      return 0
    }
  },
  session_next_session: (state, getters, rootState, rootGetters) => {
    if (state.nextSession !== null) {
      return state.nextSession
    } else {
      return 0
    }
  },
  session_next_session_time_until_start: (state, getters, rootState, rootGetters) => {
    if (state.nextSessionTimeUntilStart !== null) {
      return state.nextSessionTimeUntilStart
    } else {
      return 0
    }
  },
};
